import { useEffect, useState } from "react";
import { user_meta_data_action } from "../../../redux/_actions";
import {
  get_jobs_hiring_manager_action,
} from "../../../redux/_actions/hiringManager";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
function useHiringManagerJobs() {
  const [loading, setLoading] = useState(false);
  const [jobsPosted, setJobsPosted] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { jobsPostedData } = useSelector(
    (state) => state.get_jobs_hiring_manager_reducer
  );

  const { userMetaData } = useSelector((state) => state.user_meta_data_reducer);


  useEffect(() => {
    callApi();
  }, []);

  useEffect(() => {
    if (jobsPostedData?.data) {
      setJobsPosted(jobsPostedData?.data);
    }
  }, [jobsPostedData]);

  // get all jobs
  const callApi = async () => {
    setLoading(true);
    await dispatch(get_jobs_hiring_manager_action());
    await dispatch(user_meta_data_action())
    setLoading(false);
  };

  const onCreateJobClick = () => {
    navigate(`/create-job/`);
  }

  return {
    loading,
    jobsPosted,
    userMetaData,
    onCreateJobClick
  };
}
export default useHiringManagerJobs;
